import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";

import {DATE_FORMAT_ISO} from "config/constants";
import DatePicker from "v2/components/DatePicker";

const CalendarPage = (props, context) => {
  const {location: {query}, params: {date}, router} = context;
  const url = `/${date}`;
  return (
    <div>
      <DatePicker
        className="erg-margin-15 erg-margin-top-30 erg-margin-bottom-30"
        onDayClick={(evt, day) => {
          router.push({
            pathname: `/${moment(day).format(DATE_FORMAT_ISO)}`,
            query: {
              ...query,
              next: undefined,
            },
          });
        }} />
      <div className="erg-margin-15 text-center">
        <a
          className="erg-remove-link"
          href="#"
          onClick={(evt) => {
            evt.preventDefault();
            router.push({
              pathname: query.next || url,
              query: {
                ...query,
                next: undefined,
              },
            });
          }}>
          <i className="fa fa-times" />Close
        </a>
      </div>
    </div>
  );
};

CalendarPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default CalendarPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/CalendarPage.js
 **/